import BooleanAttributes from './boolean';
import NumericAttributes from './numeric';
import SelectAttributes from './select';
import Error from '../../../../../../components/error';
import { AttributeType } from '../../../../../../data/types/attributes';
import {
  BaseBooleanAttribute,
  BaseNumericAttribute,
  BaseSelectAttribute,
} from '../../../../../../data/types/attributes';
import { Colors } from '../../../../../../config/theme';
import UtilitiesRepository from '../../../../../../data/repositories/utilities_repository';
import { useContext, useEffect, useState } from 'react';
import { ListingState } from '../../../../../../data/types/listings';
import { ProductListingContext } from '../../../../../../pages/create_listings/functions/data_formatting_functions';
import { PerplexityResponse } from '../../../../../../data/types/utilities';

type AttributeLayoutProps = {
  attribute: BaseBooleanAttribute | BaseNumericAttribute | BaseSelectAttribute;
  type: number;
  errors: any;
};

export default function AttributeLayout({
  attribute,
  type,
  errors,
}: AttributeLayoutProps) {
  const AttributeTypeComponent = () => {
    if (attribute.type === AttributeType.NUMERIC) {
      return <NumericAttributes attribute={attribute} productType={type} />;
    } else if (attribute.type === AttributeType.SELECT) {
      return <SelectAttributes attribute={attribute} productType={type} />;
    } else if (attribute.type === AttributeType.BOOLEAN) {
      return <BooleanAttributes attribute={attribute} productType={type} />;
    } else {
      return <div />;
    }
  };

  return (
    <div>
      {AttributeTypeComponent()}
      <AISuggestionForAttribute attribute={attribute} />
      {errors[attribute.name_en] ? (
        <Error text={errors[attribute.name_en]} />
      ) : (
        ''
      )}
    </div>
  );
}

const AISuggestionForAttribute = ({
  attribute,
}: {
  attribute: BaseBooleanAttribute | BaseNumericAttribute | BaseSelectAttribute;
}) => {
  const [suggestion, setSuggestion] = useState<PerplexityResponse>();
  const [manuallyAllowed, setManuallyAllowed] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const {
    state,
  }: {
    state: ListingState;
  } = useContext(ProductListingContext);

  useEffect(() => {
    const fetchSuggestion = async () => {
      setLoading(true);
      await UtilitiesRepository.suggestAttributeValueForItem({
        productNameEn: state.data.name_en,
        productManfacturerBarcode: state.data.barcode,
        requestedAttributeNameEn: attribute.name_en,
        attributeType:
          attribute.type === AttributeType.NUMERIC
            ? 'numeric'
            : attribute.type === AttributeType.SELECT
              ? 'Most Accurate Value (Select on of many)'
              : 'Yes/No',
        attributeUnit:
          attribute.type === AttributeType.NUMERIC ? attribute.unit : undefined,
      })
        .then((res) => {
          if (!res || res === null) {
            return;
          }
          setSuggestion(res);
        })
        .catch(() => {
          setError(true);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    if (
      !manuallyAllowed &&
      (state.userType !== 1 ||
        state.data.barcode === '' ||
        !state?.data?.barcode ||
        attribute.is_variable)
    )
      return;
    fetchSuggestion();
  }, [
    state.data.name_en,
    state.data.barcode,
    attribute,
    state.userType,
    manuallyAllowed,
  ]);

  return (
    <p className="mt-1 mb-4">
      <span
        className="font-bold"
        style={{
          color: Colors.grey,
          cursor: 'pointer',
        }}
        onClick={() => {
          setError(false);
          setManuallyAllowed((prev) => {
            return !prev;
          });
        }}
      >
        {suggestion?.answer === '' ? 'Ask AI?' : 'AI Suggestion:'}
      </span>{' '}
      <span
        className="text-s font-medium"
        style={{
          color: Colors.greenAlternate,
        }}
      >
        {error
          ? 'Error, try again in few moments'
          : loading
            ? 'Loading...'
            : suggestion?.answer}
      </span>
    </p>
  );
};
